import React from 'react';
import { Button, ButtonProps } from '@mui/material';

const CadisButton = (props: ButtonProps) => {
    return (
        <Button {...props}>{props.children}</Button>
    )
}

export default CadisButton